module.exports = __webpack_public_path__ + "media/images/png/rent-white/2-78d9f28a9737d7bd0cf1aec86537e838.png";